import React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './input.module.css';
import {
  NumberInput as BaseNumberInput,
  NumberInputProps as BaseNumberInputProps,
  EmailInput as BaseEmailInput,
  EmailInputProps as BaseEmailInputProps,
  PasswordInput as BasePasswordInput,
  PasswordInputProps as BasePasswordInputProps,
  TextAreaInput as BaseTextAreaInput,
  TextAreaInputProps as BaseTextAreaInputProps,
  TextInput as BaseTextInput,
  TextInputProps as BaseTextInputProps,
  URLInput as BaseURLInput,
  URLInputProps as BaseURLInputProps,
} from 'ui/base/input';

type PublicInputStyles = {
  label: string;
  numberInput: string;
  textInput: string;
  textAreaInput: string;
  passwordVisibilityToggle: string;
};

const themedStyles: ThemedStyles<PublicInputStyles> = {
  [Theme.DAYLIGHT]: {
    label: baseStyles.daylightLabel,
    numberInput: baseStyles.daylightNumberInput,
    textInput: baseStyles.daylightTextInput,
    textAreaInput: baseStyles.daylightTextAreaInput,
    passwordVisibilityToggle: baseStyles.daylightPasswordVisibilityToggle,
  },
  [Theme.MIDNIGHT]: {
    label: baseStyles.midnightLabel,
    numberInput: baseStyles.midnightNumberInput,
    textInput: baseStyles.midnightTextInput,
    textAreaInput: baseStyles.midnightTextAreaInput,
    passwordVisibilityToggle: baseStyles.midnightPasswordVisibilityToggle,
  },
};

export type LabeledInputProps = {
  label: string;
  children: React.ReactNode;
};

export const LabeledInput = ({ label, children }: LabeledInputProps) => {
  const styles = useStyles(themedStyles);
  return (
    <>
      <div className={styles.label}>
        {label}
      </div>
      {children}
    </>
  );
};

export type NumberInputProps = Omit<BaseNumberInputProps, 'className'>;
export const NumberInput = (props: NumberInputProps) => {
  const styles = useStyles(themedStyles);
  return <BaseNumberInput className={styles.numberInput} {...props}/>;
};

export type TextAreaInputProps = Omit<BaseTextAreaInputProps, 'className'>;
export const TextAreaInput = (props: TextAreaInputProps) => {
  const styles = useStyles(themedStyles);
  return <BaseTextAreaInput className={styles.textAreaInput} {...props}/>;
};

export type TextInputProps = Omit<BaseTextInputProps, 'className'>;
export const TextInput = (props: TextInputProps) => {
  const styles = useStyles(themedStyles);
  return <BaseTextInput className={styles.textInput} {...props}/>;
};

export type URLInputProps = Omit<BaseURLInputProps, 'className'>;
export const URLInput = (props: URLInputProps) => {
  const styles = useStyles(themedStyles);
  return <BaseURLInput className={styles.textInput} {...props}/>;
};

export type EmailInputProps = Omit<BaseEmailInputProps, 'className'>;
export const EmailInput = (props: EmailInputProps) => {
  const styles = useStyles(themedStyles);
  return <BaseEmailInput className={styles.textInput} {...props}/>;
};

export type PasswordInputProps = Omit<BasePasswordInputProps, 'className'>;
export const PasswordInput = (props: PasswordInputProps) => {
  const styles = useStyles(themedStyles);
  return <BasePasswordInput className={styles.textInput} visibleClassName={styles.passwordVisibilityToggle} {...props}/>;
};
